// extracted by mini-css-extract-plugin
module.exports = {"singleWidth":"Codeword_singleWidth__1TOU0","fadeIn":"Codeword_fadeIn__11x6j"};